import { render, staticRenderFns } from "./dev-header.vue?vue&type=template&id=dbe0b518&"
import script from "./dev-header.vue?vue&type=script&lang=ts&"
export * from "./dev-header.vue?vue&type=script&lang=ts&"
import style0 from "./dev-header.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports